export enum UserTypes {
  Owner = 'owner',
  Manager = 'manager',
  Caretaker = 'caretaker',
  IndependentContractor = 'independent_contractor',
  Tenant = 'tenant',
  Admin = 'admin',
  SalesPerson = 'salesperson',
  SimpleUser = 'simple_user',
  // ManagerAdmin = 'manager-admin',
  // caretaker2 = 'concierge',
  SuperAdmin = 'superadmin',
  Customer = 'customer',
  InternalContractor = 'internal_contractor',
  MaintenanceReferent = 'maintenance_referent',
  ExternalProvider = 'external_provider',
  ExternalProviderMember = 'external_provider_member',
  VehicleReferent = 'vehicle_referent',
  PlusUser = 'plus_user',
}

export enum UserTypesIcon {
  OwnerIcon = 'icon-owner',
  ManagerIcon = 'icon-manager-admin',
  IndependentContractorIcon = 'icon-independent-contractor',
  TenantIcon = 'icon-tenant',
  ManagerBasicIcon = 'icon-manager-basic'
}

export enum UserTemplate {
  default = 'default',
  serviceBookAgency = 'service_book_agency',
  serviceBookOwner = 'service_book_owner'
}



// WEBPACK FOOTER //
// ./src/common/enums/user-types.enum.ts